import { paginationCalculator } from "pagination-calculator";

export const createHeaders = () => {
    return [
        {

            name: 'Matching candidate',

            field: 'matching',

            type: 'icon',

            minWidth: 150

        },
        {
            name: 'Location',
            field: 'locationName',
            type: 'text',
            sort: true,
            filter: true,
            minWidth: 250
        },
        {
            name: 'Shift Date',
            field: 'jobDateToDisplay',
            type: 'text',
            sort: true,
            filter: true,
            minWidth: 210
        },
        {
            name: 'Start Time',
            field: 'shiftStartTime',
            type: 'text',
            sort: true,
            filter: true,
            minWidth: 150
        },
        {
            name: 'End Time',
            field: 'shiftEndTime',
            type: 'text',
            sort: true,
            filter: true,
            minWidth: 150
        },
        {
            name: 'Claimed',
            field: 'isClaimed',
            type: 'icon',
            minWidth: 100
        },
        {
            name: 'First Name',
            field: 'candidateFirstName',
            type: 'text',
            filter: true,
            sort: true,
            minWidth: 150
        },
        {
            name: 'Last Name',
            field: 'candidateLastName',
            type: 'text',
            filter: true,
            sort: true,
            minWidth: 150
        },
        {
            name: 'Ratings',
            field: 'ratings',
            type: 'ratings',
            minWidth: 120
        },
        {
            name: 'Checkin',
            field: 'isCheckedIn',
            type: 'icon',
            filter: false,
            sort: false,
            minWidth: 150
        },
        {
            name: 'GPS',
            field: 'gpsTrackingStatus',
            type: 'icon',
            filter: false,
            sort: true
        },
        {
            name: 'Checkout',
            field: 'isCheckedOut',
            type: 'icon',
            filter: false,
            sort: false
        },
        {
            name: 'Approval',
            field: 'jobApproversList',
            type: 'icon',
            filter: false,
            sort: false
        },
        {
            name: 'Paid',
            field: 'isPaid',
            type: 'icon',
            filter: false,
            sort: false
        },
        {
            name: 'Message',
            field: 'message',
            type: 'icon',
            filter: false,
            sort: true
        },
        {
            name: 'View',
            field: 'view',
            type: 'icon'
        },
        {
            name: 'Edit',
            field: 'edit',
            type: 'icon'
        },
        {
            name: 'Delete',
            field: 'delete',
            type: 'icon'
        },
    ]
}


export const createPageData = (page, pageSize, totalCount) => {
    if (page === 1) {
        return {
            from: page,
            to: pageSize,
            total: totalCount,
            totalPages: Math.ceil(totalCount / pageSize),
            currentPage: page,
            pageSize: pageSize
        }
    } else {
        const pageData = paginationCalculator({
            total: totalCount,
            current: page,
            pageSize: pageSize
        });
        return {
            from: pageData.showingStart,
            to: pageData.showingEnd,
            total: totalCount,
            totalPages: Math.ceil(totalCount / pageSize),
            currentPage: page,
            pageSize: pageSize
        }
    }
}
